import { Component } from '@angular/core'

@Component({
  selector: 'kit-antd-timeline-example',
  templateUrl: './timeline.component.html',
})
export class KitAntdTimelineExampleComponent {}
